import React, { useState } from "react";
import { useDeleteRole, useGetUserRoles } from "../../../../backend/users";
import RoleDetails from "./RoleDetails";
import AddEditRole from "./AddEditRole";
import { CellTmpl, reactFormatter } from "../../../../components/common/Table";
import { VIEWS } from "./Roles";
import BaseList from '../../../../components/common/BaseList';
import { RoleSchema } from '../../../../models/role';

function ManageRoles({ changeView }: { changeView: (view: VIEWS, data: any) => void }) {
    const [breadcrumb] = useState([
      { id: 'home', label: 'Home', path: '/' },
      { id: 'userManagement', label: 'User Management', path: '/userManagement/roles' },
      { id: 'roles', label: 'Manage Roles' },
    ]);

    const columns = [
      { title: "Role", field: "name", formatter: reactFormatter(<CellTmpl />), widthGrow: 1 },
      { title: "Description", field: "description", formatter: reactFormatter(<CellTmpl />), widthGrow: 2 }
    ]

    // Create a wrapper FormView component to handle updatePrivileges
    const FormViewWrapper = (props: any) => {
      return <AddEditRole 
        {...props} 
        updatePrivileges={(role: any) => changeView(VIEWS.ADD, role)} 
      />;
    };

    return (
      <BaseList
        fetchData={useGetUserRoles}
        deleteData={useDeleteRole}
        nameAttribute={'name'}
        columns={columns}
        DetailView={RoleDetails}
        FormView={FormViewWrapper}
        modelSchema={RoleSchema}
        initialSort={['name asc']}
        breadcrumb={breadcrumb}
        title="Manage Roles"
      />
    );
}

export default ManageRoles;
